import React from "react"
import { Checkbox } from "antd"

// hoc
import InputWrapper from "../../hoc/InputWrapper/InputWrapper"

// styles
import "./RJSingleCheckbox.scss"

const RJSingleCheckbox = (props) => {
  let { carbonProps, value, onChange } = props
  let checked = false
  if (value === false || value == true) checked = value

  return (
    <div className="rjs-single-checkbox-widget">
      <Checkbox
        id={props.id + "-single-checkbox-field"}
        checked={checked}
        disabled={carbonProps.disabled}
        onChange={(e) => onChange(e.target.checked)}
      />
    </div>
  )
}

export default InputWrapper(RJSingleCheckbox)
